import { render, staticRenderFns } from "./convertToInvoiceForm.vue?vue&type=template&id=19bc5dec"
import script from "./convertToInvoiceForm.vue?vue&type=script&lang=js"
export * from "./convertToInvoiceForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports